import _extends from "@babel/runtime/helpers/extends";
/* eslint-disable */
/* tslint:disable */
import * as React from 'react';
const PremiumIcon = _ref => {
  let {
    size,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 14 12",
    fill: "currentColor",
    width: size || '14',
    height: size || '12'
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M14 0l-1 9H1L0 0h1c.75 0 1 3 3 3s2-3 2-3h2s0 3 2 3 2.25-3 3-3h1zm-1 12H1v-1h12v1z"
  }));
};
PremiumIcon.displayName = 'PremiumIcon';
export default PremiumIcon;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=PremiumIcon.js.map